import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import { usePageHeaders } from '@/src/hooks/use-page-headers/usePageHeaders'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import MyTeamTabs from '@/src/components/my-team/my-team-tabs/MyTeamTabs'
import { useTeamNavigation } from '@/src/hooks/use-team-navigation/useTeamNavigation'
import { MonthFilterSelect } from '@/src/components/month-filter-select/MonthFilterSelect'
import { usePeriodValueFilter } from '@/src/hooks/use-period-value-filter/usePeriodValueFilter'

const Layout = () => {
  const { t } = useTranslation('common')
  const { tab, onTabChange } = useTeamNavigation()
  const { team } = useUserPreferences(userPreferencesPort)
  const { periodValue, setPeriodValue } = usePeriodValueFilter()
  usePageHeaders(t('pages.my-team.title'), `${team?.name}`)

  return (
    <div className="h-full overflow-auto flex flex-col">
      <div className="bg-white rounded-t-2xl p-5 flex-1 flex flex-col gap-4">
        <MyTeamTabs value={tab} onChange={onTabChange} />
        <MonthFilterSelect value={periodValue} onChange={setPeriodValue} />
        <Outlet key={tab} context={{ month: periodValue }} />
      </div>
    </div>
  )
}

export default Layout
